export default {
	'main-info': 'Main info',
	archive: 'archive',
	unarchive: 'unarchive',
	'change-archive-status': 'Change archive status',
	'change-archive-status-alert': 'Are you share you want to change archive state of the account?',
}